import TypeToReducer from 'type-to-reducer';

import { normalize, schema } from 'normalizr';

import {
  GET_GROUPS,
  SET_GROUPS_PAGINATION,
  SET_GROUPS_FILTERS,
  RESET_GROUPS,
  TOGGLE_GROUP,
} from 'groups/constants';
import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';

const group = new schema.Entity('groups');

export const initialState = {
  filters: {
    fulltext: '',
    columnSearch: ['key', 'name', 'description', 'module'],
  },
  pagination: {
    page: 1,
    limit: 10,
    totalPages: 0,
    totalDocs: 0,
    orderBy: 'createdAt',
    order: 'desc',
  },
  isLoading: false,
  needFetch: false,
  entities: { groups: {} },
  result: { groups: [] },
};

export const getPending = (state) => ({ ...state, isLoading: true, needFetch: false });
export const getFulfilled = (state, { payload }) => {
  const pagination = {
    ...state.pagination,
    limit: payload.limit,
    page: payload.page,
    totalPages: payload.totalPages,
    totalDocs: payload.totalDocs,
  };

  const normalized = normalize({ groups: payload.records }, { groups: [group] });

  return { ...state, isLoading: false, pagination, ...normalized };
};
export const getRejected = (state) => ({ ...state, isLoading: false });

export const setPagination = (state, { payload }) => ({
  ...state,
  needFetch: true,
  pagination: { ...state.pagination, ...payload },
});

export const setFilters = (state, { payload }) => ({
  ...state,
  needFetch: true,
  filters: { ...state.filters, ...payload },
});

export const reset = (state) => ({ ...initialState });

export const togglePending = (state, { meta }) => ({
  ...state,
  entities: {
    ...state.entities,
    groups: {
      ...state.entities.groups,
      [meta.id]: { ...state.entities.groups[meta.id], isLoading: true },
    },
  },
});

export const toggleRejected = (state, { meta }) => ({
  ...state,
  entities: {
    ...state.entities,
    groups: {
      ...state.entities.groups,
      [meta.id]: { ...state.entities.groups[meta.id], isLoading: true },
    },
  },
});

export const toggleFulfilled = (state, { payload }) => ({
  ...state,
  entities: {
    ...state.entities,
    groups: {
      ...state.entities.groups,
      [payload.project.id]: { ...payload.project, isLoading: false }, // Esto se debe cambiar por group
    },
  },
});

const groupsListReducers = {
  [GET_GROUPS]: {
    [PENDING]: getPending,
    [FULFILLED]: getFulfilled,
    [REJECTED]: getRejected,
  },
  [SET_GROUPS_PAGINATION]: setPagination,
  [SET_GROUPS_FILTERS]: setFilters,
  [RESET_GROUPS]: reset,
  [TOGGLE_GROUP]: {
    [PENDING]: togglePending,
    [REJECTED]: toggleRejected,
    [FULFILLED]: toggleFulfilled,
  },
};

export default TypeToReducer(groupsListReducers, initialState);



// WEBPACK FOOTER //
// src/modules/secured/modules/groups/reducers/groups_list_reducers.js